import classNames from 'classnames';
import { JoditTextEditor } from 'components/JoditTextEditor';

import './SettlementEmailJoditEditor.css';

interface Props {
  className?: string;
  classNameEditor?: string;
  text?: string;
  onChange?: (value: string) => void;
}

export const SettlementEmailJoditEditor = ({ className, text, onChange }: Props) => {
  return (
    <JoditTextEditor
      className={classNames('settlement-email-joditeditor', className)}
      classNameEditor={classNames('settlement-email-joditeditor__editor', className)}
      value={text ?? ''}
      // Workaround: the "Save" button is not shown until editor focus is lost.
      //      using onChange instead of onTextChanged
      onChange={onChange}
    />
  );
};
